import React from "react";
import { Modal, Box, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import PropTypes from "prop-types";

function Loader({ openLoader, title }) {
  return (
    <div>
      <Modal
        open={openLoader}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="b-loader-container"
      >
        <Box className="b-loader-container__box">
          <Typography className="b-loader-container__text">
            {title}...
          </Typography>
          <CircularProgress style={{ color: "#f5f8fc" }} />
        </Box>
      </Modal>
    </div>
  );
}
Loader.propTypes = {
  openLoader: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};

export default Loader;
